/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 홍보대상탐색 페이지 컴포넌트
 * 버전 : 1.0
 * 파일명 : SchoolSearchPage.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * 수정 : 2025-07-02, 강동형 : 저작권 추가, 진입 시 즉시 검색하는 로직 개선, 더보기 리다이렉트 버튼에 따른 로직 추가
 * ================================================================ 
 * 수정 : 2025-07-02, 강동형 :  홍보 대상 추가 버튼 추가
 * 수정 : 2025-07-08, 강동형 :  홍보 대상 추가 버튼 삭제
 * ================================================================ */

import { useState, useEffect } from 'react'
import SchoolMap from 'src/components/schoolSearch/SchoolMap'
import styled from 'styled-components';
import BottomSheetFilter from 'src/components/schoolSearch/BottomSheetFilter';
import { useDialogStore, useSchoolListDialogStore } from 'src/stores/DialogStore';
import currentPositionIcon from 'src/assets/images/CurrentPosition.png'
import { useSchoolStore } from 'src/stores/SchoolStore';
import SchoolListSheet from 'src/components/schoolSearch/SchoolListSheet';
import { LoadMapDataFilter } from 'src/components/schoolSearch/LoadMapData';
import { useModalStore } from 'src/stores/ModalStore';
import ManageRegion from 'src/components/common/ManageRegion';
import { AlertSpan } from 'src/components/common/CommonStyled';
import { useStorageStore } from 'src/stores/StorageStore';
import SearchIcon from "src/assets/images/Icon_Search.svg";
import { Icon_ArrowDown } from 'src/components/common/CommonIcons';
import DialogLocation from 'src/components/schoolSearch/DialogLocation';
import TapSearchSchoolName from 'src/components/schoolSearch/TapSearchSchoolName';
import { useBackHandlerStore } from 'src/stores/UIStore';

//스타일 영역
const SearchWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;

  /* height: 91px; */
  z-index: 10;
  background-color: #fff;
  padding:10px 20px;
  border-bottom: 1px solid #DDD;
  min-height: 97.76px;
`
const SearchContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  width: 100%;
  color: #06799B;
  font-size: 18px;
  font-weight: 700;
  position: relative;
`
const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex : 1;
  height: 100%;

`
const ResearchBox = styled.div`
  z-index : 10;
  position : relative;
  display : flex;
  justify-content: center;
  margin-top: 6px;
`
const BottomButtonContainer = styled.div`
  position: fixed;
  bottom: 142px;
  left: 0;
  right: 0;
  display: flex;
  padding: 10px 20px;
  height: auto; /* 자식 높이에 맞춤 */
  z-index: 100; /* 다른 요소보다 위에 표시 */
  justify-content: center;
  align-items: center;
`
const CurrentPositionIMG = styled.img`
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.15);
  border-radius: 50%; /* 원형 그림자 적용 */
  right: 10px;
  position: absolute;
`
const RoundButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: auto;
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 24px;
  background-color: white;
  border: 1px solid #dddddd;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);
  color: #06799B;
  box-sizing: border-box;
  cursor: pointer;
  font-family: 'Pretendard';
`;

//로직 영역
const SchoolSearch = () => {
  const setOpen = useDialogStore((state) => state.setOpen);
  const setField = useDialogStore((state) => state.setField);
  const schools = useSchoolStore((state)=>state.schools)
  const reset = useSchoolStore((state)=>state.reset)
  const resetSchoolList = useSchoolListDialogStore((state)=>state.reset)
  const [geoLocation,setGeolocation] = useState<Geolocation | undefined>(undefined);
  const [trigger, setTrigger] = useState(false)
  const resetDialog = useDialogStore((state)=>state.reset)
  const loadBy = useDialogStore((state)=>state.loadBy)
  const modalReset = useModalStore((state)=>state.reset)

  const selected_Regions = useDialogStore((state)=>state.selected_Regions)
  const locations = useDialogStore((state)=>state.locations)
  const setLocations = useDialogStore((state)=>state.setLocations)
  const setRegions = useDialogStore((state)=>state.setRegions)
  const getUserdata = useStorageStore().getItem('user').data.user_area
  const [isvalid,setIsvalid] = useState(true)
  const [tap,setTap] = useState(false)
  const [centerPos,setCenterPos] = useState(false)
    const setCustomAction = useBackHandlerStore((state)=>state.setCustomAction)

  useEffect(()=>{
    // 뒤로가기 대신 이 액션을 실행함!
    if(tap){
      setCustomAction(()=>{
            setTap(false);
            })
        }
    else{
      setCustomAction('')
    }
  },[tap])


  useEffect(() => {
    const init = async () => {
      if (selected_Regions && Object.keys(selected_Regions).length > 0) {
        await setLocations(selected_Regions); // ✅ selected_Regions가 있으면 그걸로
      } else {
        await setLocations(getUserdata); // ✅ 없으면 기본값
      }
    };
    init(); // 🔁 async 함수 실행
    
    if (!selected_Regions || Object.keys(selected_Regions).length === 0) {
      setRegions(); // ✅ selected_Regions가 비었을 때
    }
  }, []);
const [didFirstRun, setDidFirstRun] = useState(false);
useEffect(() => {
  if(Object.keys(locations).length === 0) return  
  if (!didFirstRun) {
    setDidFirstRun(true);
    return;
  }
  const run = async () => {
    await setRegions();
    if(loadBy === 'schoolName'){
      setField('loadBy','')
      return
    }
    LoadMapDataFilter();
  };

  run();
}, [locations]);

useEffect(()=>{
  if (!locations || Object.keys(locations).length === 0) {
    setIsvalid(false);
    return;
  }

  setIsvalid(true);
},[locations])

  useEffect(()=>{
    
    return()=>{
      reset()
      resetDialog(false)
      modalReset()
      resetSchoolList()
    }
  },[])


  const handleClick = ()=>{
    setGeolocation(navigator.geolocation)
    setTrigger((state)=>!state)
  }
  const [geoTrigger,setGeoTrigger] = useState(false)
  const onClickSearchOnPos = async ()=>{
    setGeoTrigger((state)=>!state)
    setCenterPos(true)
  }

  const key = Object.keys(locations);
  const value = locations[key[0]]?.[0] ?? ''
  const firstRegion = key[0]
  const otherCount = Object.values(locations).reduce(
    (sum, arr) => sum + arr.length,
    -1
  );
  
  const onClickLocation = ()=>{
    if(loadBy === 'schoolName') return;
    setField('element',<DialogLocation/>)
    setOpen(true)
  }

  return (
    <>
      {tap ?
        <TapSearchSchoolName setTap={setTap}/>
        :
        <>
        <SearchWrapper onClick={onClickLocation}>
            {isvalid ?
              loadBy !== 'schoolName' ? 
              <>
                <SearchContainer>
                  <SearchBox>
                    <span>{firstRegion} {value}</span>
                    {otherCount !== 0 &&
                      <span> 외 {otherCount}개</span>
                    }
                    <Icon_ArrowDown sx={{width:'16px', height:'16px'}}/>
                  </SearchBox>
                  <img src={SearchIcon} style={{marginLeft:'auto', width:'21px', height:'21px', zIndex:11}} onClick={(e)=>{e.stopPropagation()
                  setTap(true)}}/>
                </SearchContainer>
                <SearchContainer style={{overflowX:'auto', whiteSpace:'nowrap', marginLeft:'-6px'}} className='hide-scrollbar'>
                  <ManageRegion user_area={locations} isModify={false}/>
                </SearchContainer>
              </>
              //loadBy 조건
              :
              <>
                <SearchContainer>
                  <SearchBox style={{fontWeight:600, color:'#454545'}}>
                    <span>지역 선택</span>
                    <Icon_ArrowDown sx={{width:'16px', height:'16px'}}/>
                  </SearchBox>
                  <img src={SearchIcon} style={{marginLeft:'auto', width:'21px', height:'21px', zIndex:11}} onClick={(e)=>{e.stopPropagation()
                  setTap(true)}}/>
                </SearchContainer>
                <SearchContainer style={{overflowX:'auto', whiteSpace:'nowrap', marginLeft:'-6px'}} className='hide-scrollbar'>
                  <ManageRegion user_area={locations} isModify={false} disable={true}/>
                </SearchContainer>
              </>
            //isValid False 조건
            :
              <>
              <SearchContainer>
                <AlertSpan $isValid={false} style={{height:'23.76px', padding:'0px', display:'flex', alignItems:'center'}}>담당 지역을 1개 이상 설정해주세요</AlertSpan>
                <img src={SearchIcon} style={{marginLeft:'auto', width:'21px', height:'21px'}}/>
              </SearchContainer>
              <SearchContainer>
                &nbsp;
              </SearchContainer>
              </>
            }
        </SearchWrapper>
        <SchoolMap schools={schools} geo={geoLocation} trigger={trigger} geoTrigger={geoTrigger} setCenterPos={setCenterPos}>
          <ResearchBox>
            {(loadBy === 'schoolName' || (loadBy === 'currentGeo' && centerPos)) ? (
              <RoundButton onClick={LoadMapDataFilter} style={{ backgroundColor: '#06799B', color: '#fff' }}>
                선택 지역으로 돌아가기
              </RoundButton>
            ) : (
              <RoundButton onClick={onClickSearchOnPos}>
                현재 지도 내 검색
              </RoundButton>
            )}
          </ResearchBox>
          <BottomButtonContainer>
            <CurrentPositionIMG src={currentPositionIcon} onClick={()=>handleClick()}/>
          </BottomButtonContainer>
        </SchoolMap>
        <BottomSheetFilter/>
        <SchoolListSheet initialSchools={schools}/>
        </>
      }
    </>
  )
}

export default SchoolSearch